import { h, Host } from "@stencil/core";
import { AppState } from "../../service/app-state";
export class Offcanvas {
    constructor() {
        this.open = false;
        this.changeListener = () => {
            this.open = AppState.offcanvas;
        };
    }
    openChanged(open) {
        if (open) {
            document.body.classList.add('offcanvas-active');
        }
        else {
            document.body.classList.remove('offcanvas-active');
        }
    }
    componentDidLoad() {
        this.open = AppState.offcanvas;
        AppState.addEventListener(this.changeListener);
    }
    disconnectedCallback() {
        AppState.removeEventListener(this.changeListener);
    }
    render() {
        const backdropProps = {
            class: `offcanvas-backdrop ${this.open ? 'open' : ''}`,
            onClick: () => AppState.toggleOffcanvas()
        };
        return h(Host, { key: 'c23489a64495526306844c766262eee6e16c54de', class: "inverted" }, h("slot", { key: 'a09170c9aff21dc57a114350c20db4372efa3f31' }), h("div", Object.assign({ key: 'a4578a49c733ffa0b578642b7e16dbdbffc9eb47' }, backdropProps)));
    }
    static get is() { return "uvex-offcanvas"; }
    static get originalStyleUrls() {
        return {
            "$": ["./offcanvas.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["offcanvas.css"]
        };
    }
    static get states() {
        return {
            "open": {}
        };
    }
    static get watchers() {
        return [{
                "propName": "open",
                "methodName": "openChanged"
            }];
    }
}
//# sourceMappingURL=offcanvas.js.map
